module.exports = __webpack_public_path__ + "static/img/icon-home.cecb1b7e.svg";